<template>
  <div class="products-new-view">
    <h1 v-if="isBundle">{{$t('titles.newBundle')}}</h1>
    <h1 v-else>{{$t('titles.newStandard')}}</h1>
    <bundle-product-form
      :disabled="isSubmitting"
      :errors="errors"
      :product-family="productFamily"
      @submit="insertBundleProduct"
      v-if="isBundle"
    />
    <standard-product-form
      :disabled="isSubmitting"
      :errors="errors"
      :product-family="productFamily"
      @submit="insertStandardProduct"
      v-else
    />
  </div>
</template>

<script>
import BundleProductForm from '@/components/BundleProductForm';
import insertBundleProductMutation
  from '@/api/mutations/insert-bundle-product.graphql';
import insertStandardProductMutation
  from '@/api/mutations/insert-standard-product.graphql';
import productFamilyQuery from '@/api/queries/product-family.graphql';
import StandardProductForm from '@/components/StandardProductForm';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';
import View from '@/mixins/View';

export default {
  name: 'products-new-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    StandardProductForm,
    BundleProductForm,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'new',
          route() {
            let name;
            if (this.isBundle) {
              name = 'new-bundle-product';
            } else {
              name = 'new-standard-product';
            }
            return { name };
          },
        },
      ];
    },
    isBundle() {
      return this.$route.meta.isBundle;
    },
    productFamilyId() {
      return this.$route.query.familyId;
    },
  },
  apollo: {
    productFamily: {
      query: productFamilyQuery,
      variables() {
        return { id: this.productFamilyId };
      },
      skip() {
        return !this.productFamilyId;
      },
    },
  },
  methods: {
    async insertStandardProduct(product) {
      const operation = await this.submitWithMutation({
        mutation: insertStandardProductMutation,
        variables: { product },
      });
      this.onInserted(operation);
    },
    async insertBundleProduct(product) {
      const operation = await this.submitWithMutation({
        mutation: insertBundleProductMutation,
        variables: { product },
      });
      this.onInserted(operation);
    },
    onInserted(operation) {
      if (operation.isValid) {
        const productName = operation.product.name;
        const message = this.$t('toasts.created', { name: productName });
        Toast.success(message);
        this.$router.push({
          name: 'product',
          params: { id: operation.product.id },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          newBundle: 'Bundle erstellen',
          newStandard: 'Produkt erstellen',
        },
        toasts: {
          created: 'Produkt erstellt: {name}',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// NewView.vue?0706ef74